$(document).ready(function () {
  // --- Timeline Animation ---
  const $elements = $('.timeline-num');
  const $line = $('#timeline-fill');

  if (!$elements.length || !$line.length) return;

  const totalTime = 4000;
  const delayTime = totalTime / $elements.length;

  const totalTimeTwo = 5500;
  const delayTwo = totalTimeTwo / $elements.length;

  // --- FORCE HARD INITIAL STARTING STATES ON PAGE LOAD ---
  // This guarantees the bar is hidden/empty before scrolling down to it
  if ($(window).width() > 720) {
    $line.css({
      'transition': 'none',
      'right': 'calc(100% - 48px)'
    });
  } else {
    $line.css({
      'transition': 'none',
      'height': '0px'
    });
  }

  // --- Intersection Observer Configuration ---
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -40px 0px', // Triggers 40px above the element top
    threshold: 0
  };

  const timelineObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const $el = $(entry.target);
        const index = $elements.index($el);

        if ($(window).width() > 720) {
          // Desktop View Animation
          $el.delay(index * delayTime).queue(function (next) {
            $el.addClass('filled');
            next();
          });

          // Only kick off the line growth transition when the first item is reached
          if (index === 0 && !$line.hasClass('animated')) {
            $line.addClass('animated');
            // Force browser layout repaint before adding transition properties
            $line.get(0).offsetHeight;

            $line.css({
              'transition': 'right 3.45s linear',
              'right': '48px'
            });
          }

        } else {
          // Mobile View Animation
          $el.delay(index * delayTwo).queue(function (next) {
            $el.addClass('filled');
            next();
          });

          // Only kick off the line height transition when the first item is reached
          if (index === 0 && !$line.hasClass('animated')) {
            $line.addClass('animated');
            $line.get(0).offsetHeight; // Force browser layout repaint

            $line.css({
              'transition': 'height 4.5s linear',
              'height': '338.375px'
            });
          }
        }

        // Keep item filled and stop watching it
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Bind observer to elements
  $elements.each(function () {
    timelineObserver.observe(this);
  });
});



$(document).ready(function () {

  // Helper function to process and run the numeric counting animation
  function runCounterAnimation($element) {
    const finalNumber = parseInt($element.attr('data-stat-number'), 10);
    const accent = $element.attr('data-stat-accent') || '';

    $({ countNum: 0 }).animate({ countNum: finalNumber }, {
      duration: 2000,
      easing: 'swing',
      step: function () {
        $element.text(Math.floor(this.countNum) + accent);
      },
      complete: function () {
        $element.text(finalNumber + accent);
      }
    });
  }

  // --- 1. CONFIGURATION FOR LEADERSHIP CONTAINERS ---
  // Triggers when the bottom of the screen reaches the bottom of the first .lead-stat
  $('.wp-block-acf-leadership').each(function () {
    const $container = $(this);
    const $firstLeadStat = $container.find('.lead-stat').first();
    const $counters = $container.find('.lead-stat-num');

    if ($firstLeadStat.length && $counters.length) {
      const leadershipObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          // entry.isIntersecting + threshold: 1.0 means the element's bottom edge has entered the screen
          if (entry.isIntersecting) {
            $counters.each(function () {
              runCounterAnimation($(this));
            });
            observer.unobserve(entry.target); // Unobserve so it only runs once
          }
        });
      }, {
        root: null, // Viewport tracking
        threshold: 1.0 // Requires the entire element (down to its bottom edge) to clear the bottom of the screen
      });

      leadershipObserver.observe($firstLeadStat[0]);
    }
  });

  // --- 2. CONFIGURATION FOR SOLO NUMBER CONTAINERS ---
  // Triggers when the bottom of the screen passes the top of the container
  $('.wp-block-acf-numbers-solo').each(function () {
    const containerElement = this;
    const $counters = $(this).find('.lead-stat-num');

    if ($counters.length) {
      const soloObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          // threshold: 0 means the moment 1px of the top edge crosses the bottom of the screen
          if (entry.isIntersecting) {
            $counters.each(function () {
              runCounterAnimation($(this));
            });
            observer.unobserve(entry.target); // Unobserve so it only runs once
          }
        });
      }, {
        root: null, // Viewport tracking
        threshold: 0 // Fires instantly when the top edge of the container scrolls past the bottom of the screen
      });

      soloObserver.observe(containerElement);
    }
  });

});
